import * as React from 'react';
import * as _ from 'lodash';
import { CheckBox } from 'shared_components';
import { ColorPicker } from '../../PageLayout/ColorPicker';
import classNames from 'classnames';
import { getFilterImage } from '../../../utilities/helpers';
import { bkgImage } from '../../../utilities/helpers';
import BlueDropDown from '../../PageLayout/DropDowns/BlueDropDown';
import Pager2 from '../../PageLayout/Pager2';
import Dropzone from 'react-dropzone';
import CheckBox2 from '../../PageLayout/CheckBox';
export default function () {
    function onClick1(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        this.props.updateFilterGroupItemsOrder(page * itemsToShow + idx, -1);
    }
    function onClick2(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        this.props.updateFilterGroupItemsOrder(page * itemsToShow + idx, +1);
    }
    function onClick3(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        this.confirmDeleteGroupItem(item.id);
    }
    function onClick4(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        this.props.expandFilterGroupItem(item.id);
    }
    function onChecked5(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx, value) {
        this.props.enableFilterGroupItem(item.id, !value);
    }
    function onChange6(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx, e) {
        updateProp('order', +e.target.value);
    }
    function onChange7(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx, e) {
        updateProp('displayText', e.target.value);
    }
    function onClick8(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        this.props.cancelFilterGroupItemEdit(exp.id);
    }
    function onClick9(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        this.saveGroupItem();
    }
    function repeatItem10(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx) {
        return React.createElement('li', {
            'className': classNames('filter-items-list__item', { 'filter-items-list__item--opened': this.props.expandedID === item.id }),
            'key': item.id
        }, React.createElement('div', { 'className': 'filter-items-list__item-row' }, React.createElement('div', { 'className': 'filter-items-cell filter-items-cell--sort filter-items-sort' }, page * itemsToShow + idx > 0 && !this.props.addingNewGroupItem ? React.createElement('span', {
            'className': 'filter-items-sort__up',
            'onClick': onClick1.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx),
            'key': '1552'
        }) : null, React.createElement('span', { 'className': 'filter-items-sort__number' }, page * itemsToShow + idx + 1), page * itemsToShow + idx < this.props.items.length - 1 && !this.props.addingNewGroupItem ? React.createElement('span', {
            'className': 'filter-items-sort__down',
            'onClick': onClick2.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx),
            'key': '1871'
        }) : null), React.createElement('div', { 'className': 'filter-items-cell filter-items-cell--remove' }, !this.props.addingNewGroupItem ? React.createElement('button', {
            'className': 'ui-icon-remove',
            'onClick': onClick3.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx),
            'key': '2222'
        }) : null), React.createElement('div', { 'className': 'filter-items-cell filter-items-cell--skuname' }, '\r\n              ', item.displayText, '\r\n            '), React.createElement('div', { 'className': 'filter-items-cell filter-items-cell--edit' }, React.createElement('button', {
            'className': classNames('ui-button4', 'ui-button4--edit', {
                'ui-button4--green': this.props.expandedID === item.id,
                'ui-button4--blue': this.props.expandedID !== item.id
            }),
            'type': 'button',
            'onClick': onClick4.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx)
        }, 'Edit Parameters')), React.createElement('div', { 'className': 'filter-items-cell filter-items-cell--edit' }, React.createElement(CheckBox, {
            'checked': item.enabled,
            'text': item.enabled ? 'Enabled' : 'Disabled',
            'onChecked': onChecked5.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx)
        }))), this.props.expandedID === item.id && exp ? React.createElement('div', {
            'className': 'filter-items-list__item-dropdown',
            'key': '3270'
        }, React.createElement('div', { 'className': 'filter-items-dropdown' }, React.createElement('div', { 'className': 'filter-items-dropdown__cell' }, React.createElement('div', { 'className': 'filter-items-block' }, React.createElement('span', { 'className': 'filter-items-block__title' }, 'order id'), React.createElement('div', { 'className': 'filter-items-order-id' }, React.createElement('input', {
            'type': 'number',
            'value': exp.order,
            'className': 'ui-input2 filter-items-order-id__input',
            'onChange': onChange6.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx)
        })))), React.createElement('div', { 'className': 'filter-items-dropdown__cell' }, React.createElement('div', { 'className': 'filter-items-block' }, React.createElement('span', { 'className': 'filter-items-block__title' }, 'SUPER SKU NAME'), React.createElement('div', { 'className': 'filter-items-order-id' }, React.createElement('input', {
            'className': 'ui-input2',
            'type': 'text',
            'placeholder': 'Enter Filter Display Text',
            'value': exp.displayText,
            'onChange': onChange7.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx)
        })))), React.createElement('div', { 'className': 'filter-items-dropdown__cell' }, React.createElement('div', { 'className': 'filter-items-dropdown-buttons' }, React.createElement('div', { 'className': 'filter-items-dropdown-buttons__left' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--small',
            'onClick': onClick8.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx)
        }, 'Cancel'), React.createElement('button', {
            'className': 'ui-button4 ui-button4--green ui-button4--small',
            'onClick': onClick9.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, idx)
        }, 'Save')))))) : null);
    }
    function onClick11(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick) {
        this.props.showAdditionalImages(false);
    }
    function onClick12(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, image, imageIndex) {
        this.deleteImage(image);
    }
    function onClick13(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, image, imageIndex) {
        this.selectImage(image);
    }
    function repeatImage14(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, image, imageIndex) {
        return [React.createElement('div', {
                'className': 'filter-additional-image ' + (image === this.state.selectedImage ? 'filter-additional-image--selected' : ''),
                'key': '57661'
            }, this.state.selectedImage == image ? React.createElement('div', {
                'className': 'filter-additional-image--delete',
                'onClick': onClick12.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, image, imageIndex),
                'key': '5977'
            }, 'DELETE') : null, React.createElement('div', {
                'className': 'filter-additional-image--image',
                'style': this.getAdditionalImageStyle(image),
                'onClick': onClick13.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, image, imageIndex)
            }))];
    }
    function onClick15(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, itemIndex) {
        this.setState({ selectedFilterCategory: item });
    }
    function repeatItem16(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, itemIndex) {
        return [item.values && item.values.length > 0 ? React.createElement('li', {
                'className': 'fc-cat__list-item ' + (this.state.selectedFilterCategory == item ? 'fc-cat__list-item--active' : ''),
                'onClick': onClick15.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, itemIndex),
                'key': '75981'
            }, item.name) : null];
    }
    function onChecked17(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, itemIndex) {
        this.handleToggleFilter(item);
    }
    function repeatItem18(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, itemIndex) {
        return [React.createElement('li', {
                'className': 'fc-filters__list-item',
                'key': '83971'
            }, React.createElement(CheckBox2, {
                'type': 'tiny',
                'checked': this.isFilterSelected(item),
                'text': item.displayText,
                'onChecked': onChecked17.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick, item, itemIndex)
            }))];
    }
    function onClick19(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick) {
        this.props.showAdditionalImages(false);
    }
    function onClick20(exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick) {
        this.saveAdditionalImages();
    }
    function scopeExpUpdatePropTotalPagesPageItemsToShowItemsHandlePageClick21() {
        var exp = this.props.expandedFilterGroupItem;
        var updateProp = this.props.updateExpandedFilterGroupItemProp;
        var totalPages = this.state.totalPages;
        var page = this.state.page;
        var itemsToShow = this.state.itemsToShow;
        var items = this.state.renderItems;
        var handlePageClick = this.handlePageClick;
        return React.createElement('div', { 'className': 'app-content-wrapper2 app-content-wrapper2-adj app-content-wrapper2--small' }, React.createElement('div', { 'className': 'app-content-main' }, React.createElement('div', { 'className': 'filter-items-container' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'filter-items-list' },
            _.map(items, repeatItem10.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick))
        ]), totalPages > 1 ? React.createElement(Pager2, {
            'page': page,
            'totalPages': totalPages,
            'pageClick': page => handlePageClick(page),
            'key': '5148'
        }) : null)), this.props.additionalImagesPopupVisible ? React.createElement('div', {
            'className': 'filter-additional-images-popup-container',
            'key': '5286'
        }, React.createElement('div', { 'className': 'filter-additional-images-popup' }, React.createElement('div', { 'className': 'filter-additional-images-head' }, '\r\n        Additional Images\r\n        ', React.createElement('div', {
            'className': 'filter-additional-images-head-close',
            'onClick': onClick11.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick)
        })), React.createElement('div', { 'className': 'filter-additional-images-body' }, React.createElement.apply(this, [
            'div',
            { 'className': 'filter-additional-images-left' },
            _.map(this.props.additionalImageData, repeatImage14.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick)),
            React.createElement(Dropzone, {
                'accept': 'image/jpeg, image/png',
                'onDrop': this.onAdditionalImageDrop,
                'className': 'fc-gallery__upload',
                'acceptStyle': {
                    'boxShadow': '0 0 1em green inset',
                    'backgroundColor': 'rgba(0,192,0,0.3)'
                },
                'rejectStyle': {
                    'boxShadow': '0 0 1em red inset',
                    'backgroundColor': 'rgba(192,0,0,0.3)'
                }
            }, React.createElement('div', { 'className': 'fc-gallery__upload-image' }), React.createElement('div', { 'className': 'fc-gallery__upload-text' }, React.createElement('p', {}, 'Drag and Drop Files'), React.createElement('p', {}, 'Supported File Formats: JPG and PNG')), React.createElement('span', { 'className': 'fc-gallery__upload-browser' }, '+ Select files from Browser'))
        ]), React.createElement('div', { 'className': 'filter-additional-images-center' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Filter Categories'), !this.state.selectedImage ? [!this.state.selectedFilterCategory ? React.createElement('div', { 'key': '72201' }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n                Select an Image\r\n              ')) : null] : null, this.state.selectedImage ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'fc-cat__list',
                'key': '7526'
            },
            _.map(this.props.filterGroups, repeatItem16.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick))
        ]) : null), React.createElement('div', { 'className': 'filter-additional-images-right' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Filters'), !this.state.selectedFilterCategory ? React.createElement('div', { 'key': '8124' }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n              Select a Filter Category\r\n            ')) : null, this.state.selectedFilterCategory ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'fc-filters__list',
                'key': '8312'
            },
            _.map(this.state.selectedFilterCategory.values, repeatItem18.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick))
        ]) : null)), React.createElement('div', { 'className': 'filter-additional-images-footer' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--small',
            'onClick': onClick19.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick)
        }, 'Cancel'), React.createElement('button', {
            'className': 'ui-button4 ui-button4--green ui-button4--small',
            'onClick': onClick20.bind(this, exp, updateProp, totalPages, page, itemsToShow, items, handlePageClick)
        }, 'Save')))) : null);
    }
    return scopeExpUpdatePropTotalPagesPageItemsToShowItemsHandlePageClick21.apply(this, []);
}